import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';
import { map } from 'rxjs/operators';
import { environment } from 'environments/environment';
import { ProductFamilyModel } from '@core/model/productFamily.model';
import { utiles } from '@utl/environment';
import { FilterByFamily } from '@core/model/FilterByFamily.model';
import { FilterDetail } from '@core/model/FilterDetail.model';
import { ItemInformationModel } from '@core/model/itemInformation.model';
import { SendItemModel } from '@core/model/sendItem.model';
import { SearchModel } from '@core/model/search.model';
import { DimensionItemModel } from '@core/model/dimensionItem.model';
import { ItemRatingModel } from '@core/model/itemRating.model';
import { CommonService } from './common.service';
import { Injectable } from "@angular/core";
/*Constants */
const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };

@Injectable()
export class ProductFamilyService {

  constructor(public http: HttpClient, private router: Router, private common: CommonService) {
    let data = utiles.getCacheUser();
    if (data !== null && data !== undefined) {
    } else {
      this.common._setLoading(false);
      this.router.navigate(['login']);
    }
  }

  getActiveProductFamiliesList(_model: ProductFamilyModel) {
    this.common._setLoading(true);
    const url = environment.apiURL + 'GetActiveProductFamiliesList';
    return this.http.post<ProductFamilyModel[]>(url, _model, httpOptions)
      .pipe(map(response => {
        this.common._setLoading(false);
        return response;
      }));
  }

  getItemsAndFilters(searchModel: SearchModel) {
    this.common._setLoading(true);
    const url = environment.apiURL + 'GetItemsAndFilters';
    return this.http.post<any>(url, searchModel, httpOptions)
      .pipe(map(response => {
        this.common._setLoading(false);
        return response;
      }));
  }

  getInventDimensionsByItems(itemInfoModel: ItemInformationModel) {
    const model = {
      ItemId: itemInfoModel.ItemId,
      Origin: 1,
    };

    this.common._setLoading(true);
    const url = environment.apiURL + 'GetInventDimensionsByItems';
    return this.http.post<any>(url, model, httpOptions)
      .pipe(map(response => {
        this.common._setLoading(false);
        return response;
      }));
  }

  getFamilyByItemId(itemId: string) {
    this.common._setLoading(true);
    const url = environment.apiURL + 'GetFamilyByItemId';
    return this.http.post<ItemInformationModel>(url, JSON.stringify(itemId), httpOptions)
      .pipe(map(response => {
        this.common._setLoading(false);
        return response;
      }));
  }

  getDisplayItemDetail(dimensionItemModel: DimensionItemModel) {
    this.common._setLoading(true);
    const url = environment.apiURL + 'DisplayItemDetail';
    return this.http.post<any>(url, dimensionItemModel, httpOptions)
      .pipe(map(response => {
        if (response != null) {
          this.common._setLoading(false);
        }
        return response;
      }));
  }

  async getDisplayItemDetail2(dimensionItemModel: DimensionItemModel) {
    this.common._setLoading(true);
    const url = environment.apiURL + 'DisplayItemDetail';
    let productInformation// = new ItemInformationModel();
    return await this.http.post<ItemInformationModel>(url, dimensionItemModel, httpOptions)
      .toPromise().then(data =>{
        return data;
      });
  }


  addToFavoriteItems(sendItem: SendItemModel) {
    this.common._setLoading(true);
    const url = environment.apiURL + 'AddToFavoriteItems';
    return this.http.post<any>(url, sendItem, httpOptions)
      .pipe(map(response => {
        this.common._setLoading(false);
        return response;
      }));
  }
  deleteFromFavorite(sendItem: SendItemModel) {
    this.common._setLoading(true);
    const url = environment.apiURL + 'DeleteFromFavoriteItems';
    return this.http.post<any>(url, sendItem, httpOptions)
      .pipe(map(response => {
        this.common._setLoading(false);
        return response;
      }));
  }

  saveRatingInformation(itemRatingModel: ItemRatingModel) {
    this.common._setLoading(true);
    const url = environment.apiURL + 'SaveRatingInformation';
    return this.http.post<any>(url, itemRatingModel, httpOptions)
      .pipe(map(response => {
        this.common._setLoading(false);
        return response;
      }));
  }

  getRelatedItemsByFamily(model: any) {
    this.common._setLoading(true);
    const url = environment.apiURL + 'GetRelatedItemsByFamily';
    return this.http.post<any>(url, model, httpOptions)
      .pipe(map(response => {
        this.common._setLoading(false);
        return response;
      }));
  }

  validateSetComment(model) {
    this.common._setLoading(true);
    const url = environment.apiURL + 'ValidSetComment';
    return this.http.post<any>(url, model, httpOptions)
      .pipe(map(response => {
        this.common._setLoading(false);
        return response;
      }));
  }
}

